<template>
    <div>
        <label class="m-d-0 require f-c-midgrey f-regular f-14">Diposting untuk</label>
        <div class="type d-flex f-regular f-16">
            <div
                class="options m-r-8 d-flex-between-center"
                :class="{ selected: typePosting === 0 }"
                @click="setTypePosting(0, 'repeat')"
            >
                <RadioOption :is-checked="typePosting === 0" /><span class="m-l-8">Satu kali</span>
            </div>
            <div class="options d-flex-between-center" :class="{ selected: typePosting === 1 }" @click="repeatSchedule">
                <RadioOption :is-checked="typePosting === 1" /><span class="m-l-8">Berulang</span>
            </div>
        </div>
        <div class="m-t-20 detail-posting">
            <label class="m-d-12 f-14 f-c-midgrey f-regular">Waktu posting:</label>
            <div v-if="typePosting === 0">
                <div class="d-flex m-d-12" @click="setDetailPosting('', 'schedule')">
                    <div class="m-r-8"><RadioOption :is-checked="!isSchedule" /></div>
                    <div>
                        <p class="m-d-0 f-14 f-regular f-c-black">Sekarang</p>
                        <p class="m-d-0 f-14 f-regular f-c-midgrey">Status akan diposting langsung.</p>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="m-r-8" @click="setDetailPosting(getDateNow, 'schedule')"><RadioOption :is-checked="isSchedule" /></div>
                    <div class="w-100">
                        <p class="m-d-0 f-14 f-regular f-c-black" @click="setDetailPosting(getDateNow, 'schedule')">Jadwalkan</p>
                        <p class="m-d-0 f-14 f-regular f-c-midgrey" v-if="!isSchedule">Pilih waktu untuk posting.</p>
                        <SOInputDateTime
                            v-if="isSchedule"
                            title=""
                            id="schedule-posting"
                            placeholder="01 Jan 2021, 21:00"
                            :value="getSchedule"
                            :min-date="getDateNow"
                            @get-date="setDetailPosting($event, 'schedule')"
                            @hook:mounted="onMountedTime"
                        />
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row m-d-16">
                    <div
                        v-for="(day, idx) in getDays"
                        :key="`${day.id}-${idx}`"
                        class="col-5"
                    >
                        <div class="d-flex" @click="toogleCheck(day.id)">
                            <CheckboxOption :is-checked="getDayValue(day.id) === 1" />
                            <span class="m-l-8" style="padding-top: 2px;">{{ day.label }}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <SOInputTime
                        title="Setiap jam"
                        id="schedule-posting-time"
                        placeholder="00:00"
                        :value="getTime"
                        @get-time="setDetailPosting($event, 'jam')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SOInputDateTime from "@/so-components/global/input/SOInputDateTime.vue";
import SOInputTime from "@/so-components/global/input/SOInputTime.vue";

import RadioOption from "./RadioOption.vue";
import CheckboxOption from "./CheckboxOption.vue";

import daysOfWeek from "../static/daysOfWeek";

export default {
    name: "PostingTime",
    components: {
        SOInputDateTime,
        SOInputTime,
        RadioOption,
        CheckboxOption,
    },
    props: {
        typePosting: {
            type: Number,
            default: 0, // 0 | 1
        },
        detailPosting: {
            type: Object,
            required: true,
        },
        setTypePosting: {
            type: Function,
            required: true,
        },
        setDetailPosting: {
            type: Function,
            required: true,
        },
    },
    computed: {
        getSchedule() {
            return this.detailPosting.schedule;
        },
        isSchedule() {
            return this.getSchedule ? true : false;
        },
        getTime() {
            return this.detailPosting.jam;
        },
        getDateNow() {
            return `${this.$moment().format("YYYY-MM-DD")}T${this.$moment().format("HH:mm")}`;
        },
        getTimeNow() {
            return `${this.$moment().format("HH:mm")}`;
        },
        getDays() {
            return daysOfWeek;
        },
        getDayValue() {
            return (day) => {
                return this.detailPosting[day];
            };
        },
    },
    methods: {
        onMountedTime() {
            let el = document.querySelector("label[for='schedule-posting']");
            el.setAttribute("style", "display: none;");
        },
        async repeatSchedule() {
            await this.setDetailPosting(this.getTimeNow, "jam");
            await this.setTypePosting(1, "repeat");
        },
        toogleCheck(day) {
            let val = this.getDayValue(day) === 1 ? 0 : 1;
            this.setDetailPosting(val, day);
        },
    },
};
</script>
<style scoped>
.options {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 8px 16px;
}
.selected {
    border-color: #a8c6ff;
    background-color: #edf5ff;
    color: #206cff;
}
.detail-posting {
    background: #f2f5f7;
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 12px 16px;
}
</style>
